import {
  forwardRef,
  type HTMLAttributes,
} from 'react';

import { cn } from '../../../utils/styles/cn';

/**
 * <TooltipBody> — the outer container for a tooltip. Rounds the first
 * and last children so multi-section tooltips look like a single card.
 *
 * The first-child/last-child border-radius rules live in global.css
 * (scoped to .cadactive-tooltip-body). They cannot live in a
 * JSX-rendered <style> tag because under React 18 + Vite dev the
 * resulting stylesheet isn't always parsed (same bug that broke
 * <Loading>'s gear positioning).
 */
const TooltipBody = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function TooltipBody({ className, children, ...props }, ref) {
    return (
      <div
        ref={ref}
        className={cn(
          'cadactive-tooltip-body',
          'bg-transparent rounded-t1 shadow-t2 overflow-hidden',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

export { TooltipBody };
